import React from 'react';
import PublicRouter from './PublicRouter';

const RootRouter = () => <PublicRouter />;

export default RootRouter;
